// ADS-AUTOPREVIEW 01 Schritt 3, Betreiberfreigabe 30.10.2026: kurze Themenauswahl, nur wenn die
// vorhandene KI-Einstufung einen Betrieb erkennt (mode "business"). Ein Klick startet die Generierung.
// ADS-AUTOPREVIEW 01 Stufe 4.4B/4.5, Betreiberfreigabe 31.10.2026: Suchbegriff als Hauptbutton, darunter KI-Themen,
// alle Standardwelten ungefiltert aufklappbar, freies Thema. Genau eine Auswahl je Vorgang.
import { useRef, useState } from "react";
import { generierungsbegriff, themaAusSuchbegriff } from "@/lib/generierungsbegriff";
import { absichtAusSuchbegriff } from "@/lib/generierungsbegriff"; // ADS-ABSICHT-01, Betreiberfreigabe 01.11.2026

const ZEILE = { width: "100%", height: "auto", minHeight: 48, paddingTop: 10, paddingBottom: 10, lineHeight: 1.3, overflowWrap: "anywhere" };
const RUBRIK = { fontSize: 13, fontWeight: 600, color: "var(--muted-2)", margin: "22px 0 8px" };

function Standardwelten({ welten, gesperrt, gewaehlt, onWahl }) {
  if (welten.length === 0) return null;
  return (
    <details data-testid="lp3-auswahl-standardwelten"
      style={{ marginTop: 22, textAlign: "left", border: "1px solid var(--border-2)", borderRadius: 12, background: "#fff" }}>
      <summary data-testid="lp3-auswahl-standardwelten-toggle"
        style={{ cursor: "pointer", padding: "14px 16px", fontWeight: 600, fontSize: 15, minHeight: 48 }}>
        {welten.length} Pflichtunterweisungen für Ihren Betrieb anzeigen
      </summary>
      <div style={{ display: "grid", gap: 8, padding: "0 12px 12px" }}>
        {welten.map((w, i) => (
          <button key={w.world_id} type="button" className="btn btn-ghost" disabled={gesperrt}
            style={{ ...ZEILE, paddingLeft: 14, paddingRight: 14, justifyContent: "flex-start", textAlign: "left" }}
            data-testid={`lp3-standardwelt-${i}`} onClick={() => onWahl(w.world_id)}>
            {gewaehlt === w.world_id ? `${w.title} – wird geöffnet …` : w.title}
          </button>
        ))}
      </div>
    </details>
  );
}

function EigenesThema({ gesperrt, onWahl }) {
  const [text, setText] = useState("");
  const thema = generierungsbegriff(text);
  return (
    <form data-testid="lp3-auswahl-eigenes" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}
      onSubmit={(e) => { e.preventDefault(); if (thema) onWahl(thema); }}>
      <input data-testid="lp3-auswahl-eigenes-input" aria-label="Eigenes Thema" placeholder="Eigenes Thema eingeben"
        value={text} onChange={(e) => setText(e.target.value)} maxLength={120} disabled={gesperrt} enterKeyHint="go"
        style={{ flex: "1 1 220px", minWidth: 0, minHeight: 48, fontSize: 16, padding: "0 14px",
          border: "1px solid var(--border-2)", borderRadius: 12, fontFamily: "inherit" }} />
      <button type="submit" className="btn btn-ghost" disabled={gesperrt || !thema} data-testid="lp3-auswahl-eigenes-button"
        style={{ flex: "1 1 160px", minHeight: 48 }}>
        Gefährdungsbeurteilung erstellen
      </button>
    </form>
  );
}

export default function BegriffAuswahl({ begriff, vorschlaege, standardwelten = [], onWahl, onStandardwelt }) {
  const sperre = useRef(false);
  const [gewaehlt, setGewaehlt] = useState(null);
  const waehle = (kennung, aktion) => {
    if (sperre.current) return;
    sperre.current = true;
    setGewaehlt(kennung);
    aktion();
  };
  const gesperrt = gewaehlt !== null;
  return (
    <section className="lp4-stage" data-testid="lp3-auswahl">
      <div className="lp4-msg" style={{ width: "100%" }}>
        <h2 data-testid="lp3-auswahl-titel" style={{ overflowWrap: "anywhere" }}>Sie haben nach „{begriff}“ gesucht.</h2>
        <p data-testid="lp3-auswahl-frage">
          Möchten Sie dafür eine vollständige Gefährdungsbeurteilung mit Dokumentation erstellen lassen?
        </p>
        <button type="button" className="btn btn-primary btn-lg" style={ZEILE} disabled={gesperrt}
          data-testid="lp3-auswahl-allgemein" onClick={() => waehle("begriff", () => onWahl(begriff))}>
          Ja, Gefährdungsbeurteilung für {begriff} erstellen
        </button>
        <div style={RUBRIK} data-testid="lp3-auswahl-verwandte-titel">Verwandte Themen</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
          {vorschlaege.map((v, i) => (
            <button key={v.titel} type="button" className="btn btn-ghost btn-sm" disabled={gesperrt}
              style={{ height: "auto", minHeight: 44, paddingTop: 8, paddingBottom: 8, lineHeight: 1.3 }}
              data-testid={`lp3-auswahl-option-${i}`} onClick={() => waehle(`thema-${i}`, () => onWahl(v.titel))}>
              {v.titel}
            </button>
          ))}
        </div>
        <Standardwelten welten={standardwelten} gesperrt={gesperrt} gewaehlt={gewaehlt}
          onWahl={(id) => waehle(id, () => onStandardwelt(id))} />
        <div style={RUBRIK}>Eigenes Thema</div>
        <EigenesThema gesperrt={gesperrt} onWahl={(t) => waehle("eigenes", () => onWahl(t))} />
      </div>
    </section>
  );
}

// ADS-ABSICHT-01, Betreiberfreigabe 01.11.2026: Fragetext je Absicht des Suchbegriffs, ohne Absicht der bisherige Text.
const FRAGE_JE_ABSICHT = {
  unterweisung: "Für welche Tätigkeit oder welchen Betrieb brauchen Sie die Unterweisung?",
  betriebsanweisung: "Für welche Tätigkeit oder Maschine brauchen Sie die Betriebsanweisung?",
  software: "Für welche Tätigkeit oder welchen Betrieb möchten Sie CLartext ausprobieren?",
};
const FRAGE_OHNE_ABSICHT = "Für welche Tätigkeit oder welchen Betrieb brauchen Sie die Gefährdungsbeurteilung?";

// ADS-SUCHBEGRIFF-01, Betreiberfreigabe 01.11.2026: kurze Frage, wenn der Suchbegriff nur aus Füllwörtern besteht.
// Feld und Knopf, darunter die Standardwelten; genau eine Auswahl je Vorgang.
export function ThemaFrage({ begriff, standardwelten = [], onWahl, onStandardwelt }) {
  const sperre = useRef(false);
  const [gewaehlt, setGewaehlt] = useState(null);
  const [text, setText] = useState("");
  const eingabe = generierungsbegriff(text);
  const thema = themaAusSuchbegriff(eingabe);
  const waehle = (kennung, aktion) => {
    if (sperre.current) return;
    sperre.current = true;
    setGewaehlt(kennung);
    aktion();
  };
  const gesperrt = gewaehlt !== null;
  return (
    <section className="lp4-stage" data-testid="lp3-frage">
      <div className="lp4-msg" style={{ width: "100%" }}>
        <h2 data-testid="lp3-frage-titel">{FRAGE_JE_ABSICHT[absichtAusSuchbegriff(begriff)] || FRAGE_OHNE_ABSICHT}</h2>
        <form data-testid="lp3-frage-form" style={{ display: "grid", gap: 10, marginTop: 18 }}
          onSubmit={(e) => { e.preventDefault(); if (thema) waehle("eingabe", () => onWahl(eingabe)); }}>
          <input data-testid="lp3-frage-input" aria-label="Tätigkeit oder Betrieb" placeholder="z. B. Kita, Bäckerei, Gabelstapler"
            value={text} onChange={(e) => setText(e.target.value)} maxLength={120} disabled={gesperrt} enterKeyHint="go"
            style={{ width: "100%", boxSizing: "border-box", minHeight: 48, fontSize: 16, padding: "0 14px",
              border: "1px solid var(--border-2)", borderRadius: 12, fontFamily: "inherit" }} />
          <button type="submit" className="btn btn-primary btn-lg" style={ZEILE} disabled={gesperrt || !thema}
            data-testid="lp3-frage-button">
            Gefährdungsbeurteilung erstellen
          </button>
        </form>
        <Standardwelten welten={standardwelten} gesperrt={gesperrt} gewaehlt={gewaehlt}
          onWahl={(id) => waehle(id, () => onStandardwelt(id))} />
      </div>
    </section>
  );
}
